import { PrescriptionPadStep } from '@/components/PatientPageV2/components/PrescriptionPad';
import type { PrescriptionAttributes, TypedResponse } from '@/types';
import { toast } from '@montugroup/design-system';

type PrimaryButtonToolTipType = {
  isActionChecklistIncomplete: boolean;
  isPrescriptionPadInSync: boolean;
  hasCompletedActions: boolean;
  isDispenseLimitExceededNoteEmpty: boolean;
};

export const getPrimaryButtonTooltip = ({
  isActionChecklistIncomplete,
  isPrescriptionPadInSync,
  hasCompletedActions,
  isDispenseLimitExceededNoteEmpty,
}: PrimaryButtonToolTipType) => {
  if (!isPrescriptionPadInSync) {
    return 'Prescription data is outdated. Reload to continue.';
  }
  if (isActionChecklistIncomplete) {
    return 'Please complete the required actions checklist';
  }
  if (isDispenseLimitExceededNoteEmpty) {
    return 'Please add a dispense note to proceed';
  }
  if (!hasCompletedActions) {
    return 'Please select reissue or cancel for current active scripts to proceed';
  }

  return '';
};

export const createPrimaryButtonLabel = (step: PrescriptionPadStep) => {
  return step === PrescriptionPadStep.Create ? 'Review Script' : 'Create Script';
};

export const showErrorNotification = () => {
  toast.error({
    title: 'Prescription Not Created',
    message: 'Error happened while eprescription creation, Please try again!',
  });
};

export const handleResponse = async (response: TypedResponse<PrescriptionAttributes>) => {
  if (!response || response?.status >= 300) {
    throw new Error(`Unexpected response status: ${response?.status}`);
  }
  // @ts-expect-error: TS2339: type needs to be fixed
  const prescriptionCode = response.body.prescription?.orderCode || '';

  toast.success(`Prescription - ${prescriptionCode} has been processed and ePrescription is also created!`);
};
